import { editorialDashModuleQuery, useModule } from 'system/structure-modules';

export default function EditorialDashboardSpacesScreen() {
    const { SpaceListTab } = useModule(editorialDashModuleQuery);
    return <SpaceListTab />;
}
